module.exports = __webpack_public_path__ + "img/cg.d7d94b55.png";